const addressFieldsConfig = {
  city: { maxLength: 50 },
  city1: { maxLength: 50 },
  city2: { maxLength: 50 },
  line1: { maxLength: 255 },
  line2: { maxLength: 255 },
  line21: { maxLength: 255 },
  line22: { maxLength: 255 },
  stateProvince: { maxLength: 50 },
  stateProvince1: { maxLength: 50 },
  stateProvince2: { maxLength: 50 },
  postalCode: { maxLength: 10 }
}

export default addressFieldsConfig
